/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../../common/util/Permission';

export default declareLinkedEntity({
    entity: "operationDefs",
    graphQL: "OperationDef",
    name: "Operation Definition",
    dynamoPrefix: 'def',
    storageType: 'schema',
    defaultTitle: (data) => {
        return data['name'];
    },
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    isPublic: true,
    parentRelation: 'operationDefs',
    defaultOrder: ['name'],
    onModify: ['groupDef'],
    fields: (types) => { return {
        id: {
            name: "Operation Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
            compositeKey: true,
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        name: {
            name: "Operation name",
            type: "string",
            trim: true,
            defaultValue: "",
            required: true,
            translatable: true,
            isPublic: true,
        },
        externalId: {
            name: "External ID",
            type: "string",
            defaultValue: "",
            filterable: true,
        },
        key: {
            name: "Key",
            trim: true,
            type: "string",
            isPublic: true,
            defaultValue: "",
            validations: {
                matchRegexp: /^[a-zA-Z0-9\.\-_]+$/,
            }
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: "",
            translatable: true,
            isPublic: true,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
